<ng-container *ngIf="isLoading$ | async">
  <div data-test-id="global-spinner" class="global-spinner">
    <div class="spinner-grow text-primary load m-4" role="status"></div>
  </div>
</ng-container>
